import React from 'react';
import './Footer.css';

function Footer() {
  return <footer>
    <span id='copyright'>&copy; Furniture Mission of the Red River Valley</span>
    <div>
      <div className='footer-div'>
        <p><span className='info'>Mailing Address:</span> P.O. Box 7337, Fargo, ND 58106</p>
      </div>
      <div className='footer-div'>
        <p><span className='info'>Telephone:</span> 701-729-1410</p>
      </div>
      <div className='footer-div'>
        <p id='address'><span className='info'>Warehouse Address:</span> <a href="https://www.google.com/maps/place/2600+3rd+Ave+N,+Fargo,+ND+58102/@46.8789044,-96.8226554,17z/data=!3m1!4b1!4m5!3m4!1s0x52c8cbbf25403aad:0xcd6fcd03ea32784b!8m2!3d46.8789044!4d-96.8204667"> 2600 3rd Avenue North, Fargo, ND 58102</a></p>
      </div>
    </div>
  </footer>;
}

export default Footer;
